<!-- <div class="map-container">
    <div id="map0" class="map"></div>
    <div id="map1" class="map"></div>
    <div id="map2" class="map"></div>
</div> -->

<app-split-view [onBaseMapReady]="onBaseMapReady.bind(this)" [onBaseMapLoaded]="onBaseMapLoaded.bind(this)"
    [onNewMapAdded]="onNewMapAdded.bind(this)" [onLastMapRemoved]="onLastMapRemoved.bind(this)"></app-split-view>
<canvas id="deck-canvas" style="top: 0px; left: 0px;" [style.display]="getDeckVisibility()"></canvas>
<app-potree-cesium-viewer></app-potree-cesium-viewer>
<div class="bentleyContainer w-100 h-100 bg-white">
	
</div>
<div id="embedContainer" class="w-100 h-100 bg-white" *ngIf="isEmbed && embedUrl">
    <iframe [src]="embedUrl" frameborder="0" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>
</div>
<app-openlayer *ngIf="showFacade" [_zoomifyWidth]="zoomifyWidth" [_zoomifyHeight]="zoomifyHeight"
    [zoomFitToFeature]="zoomFitToFeature" (_drawnItems)="onDrawingsChanges($event)" [_zoomifyUrl]="zoomifyUrl"
    [isZoomifyRetina]="false" [_drawMode]="openlayerDrawmode" [_drawings]="savedDrawings"
    [_deleteSelected]="deleteSelected" (onScreenshotCaptured)="onScreenshotCaptured($event)"
    [enableEdit]="isOlEditEnable" [drawColor]="openlayerDrawColor" (featuresClicked)="onFeaturesClicked($event)"></app-openlayer>
<!-- to debug map state -->
<!-- <h1 *ngIf="mapService.map" class="debug-map">{{ mapService.map.getBearing() }}</h1> -->
<!-- <div id="mapInfo"><p><span class="title text-left">lon:</span> {{lng}} <span class="title text-left">lat:</span> {{lat}} <span class="title text-left">z:</span> {{zoom}} </p></div> -->